import { render, staticRenderFns } from "./WeeklyChoiceStatistics.vue?vue&type=template&id=3356c430&scoped=true&"
import script from "./WeeklyChoiceStatistics.vue?vue&type=script&lang=js&"
export * from "./WeeklyChoiceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyChoiceStatistics.vue?vue&type=style&index=0&id=3356c430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356c430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3356c430')) {
      api.createRecord('3356c430', component.options)
    } else {
      api.reload('3356c430', component.options)
    }
    module.hot.accept("./WeeklyChoiceStatistics.vue?vue&type=template&id=3356c430&scoped=true&", function () {
      api.rerender('3356c430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/weekly-choice/WeeklyChoiceStatistics.vue"
export default component.exports